import React from 'react';

interface EmailInputProps {
  email: string;
  errorMessage: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

const EmailInput: React.FC<EmailInputProps> = ({ email, errorMessage, onChange, onSubmit }) => (
  <div className="nexus-content">
    <h2>Identity</h2>
    <div className="nexus-input-group">
      <label className="nexus-label">Email Address</label>
      <input
        type="email"
        className="nexus-input"
        value={email}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
    {errorMessage && (
      <div className="nexus-error-container">
        <span className="nexus-error-message">{errorMessage}</span>
      </div>
    )}
    <button className="nexus-btn" onClick={onSubmit}>Continue</button>
  </div>
);

export default EmailInput;
